import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const NationalityDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Nationality"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Nationality">
                {getFieldDecorator('nationality', {
                 initialValue: data.nationality,
                  rules: [{ required: true, message: 'Please input the Nationality!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default NationalityDialogForm;
